import { createFileRoute } from "@tanstack/react-router";
import { Forbidden } from "@/features/auth/Forbidden";

export const Route = createFileRoute("/app/forbidden")({ component: Forbidden });
